import {
  getAuth, signInWithEmailAndPassword, setPersistence, browserSessionPersistence,
} from 'firebase/auth';
import { dataService } from '../services/DataService';

const INVALID_LOGIN_CODES = new Set([
  'auth/invalid-credential',
  'auth/invalid-login-credentials',
]);

function mapSignInErrorCode(error: { code?: string, message?: string }) {
  if (
    (error.code && INVALID_LOGIN_CODES.has(error.code))
    || error.message?.includes('INVALID_LOGIN_CREDENTIALS')
  ) {
    return 'auth/wrong-password';
  }

  return error.code || 'auth/internal-error';
}

interface signInProps {
    email: string,
    password: string
}

export default async function signIn({
  email,
  password,
}: signInProps) {
  const auth = getAuth();
  await setPersistence(auth, browserSessionPersistence);

  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const res = await dataService.getItem('users', userCredential.user.uid);
    if (userCredential.user.emailVerified) {
      return {
        statusCode: res.statusCode,
        body: res.body,
      };
    }
    return {
      statusCode: 400,
      body: 'auth/user-not-verified',
      user: userCredential.user,
    };
  } catch (error: any) {
    return {
      statusCode: 400,
      body: mapSignInErrorCode(error),
    };
  }
}
